import * as React from "react";
const SvgRobot24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 20,
        fill: "black",
        viewBox: "0 0 24 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M0 0h24v15c0 .1-.004.201-.011.3a4 4 0 0 1-6.097 3.7H6.108a4 4 0 0 1-6.097-3.7A4.057 4.057 0 0 1 0 15V0Zm22 12.135A4 4 0 0 0 16.252 17H7.748A4 4 0 0 0 2 12.135V2h20v10.135ZM4 13.6a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm14 2a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
      clipRule: "evenodd"
    })
  );
export default SvgRobot24Px;
